var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardRecive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#9FA4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3332 34.6667V42.6667M41.3332 42.6667L43.9998 40.0001M41.3332 42.6667L38.6665 40.0001",
    stroke: "#28475C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3332 31.9999C45.3332 26.9716 45.3332 24.4574 43.7711 22.8953C42.209 21.3333 39.6948 21.3333 34.6665 21.3333H29.3332C24.3049 21.3333 21.7907 21.3333 20.2286 22.8953C18.6665 24.4574 18.6665 26.9716 18.6665 31.9999C18.6665 37.0282 18.6665 39.5424 20.2286 41.1045C21.7907 42.6666 24.3049 42.6666 29.3332 42.6666H34.6665",
    stroke: "#28475C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 37.3333H24",
    stroke: "#28475C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 37.3333H32.6665",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 29.3333L45.3332 29.3333",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRecive);
export default __webpack_public_path__ + "static/media/card_recive.ec7c8949b19c3b03ebe41ac8b39ba17e.svg";
export { ForwardRef as ReactComponent };